module.exports = __webpack_public_path__ + "img/23.348eced3.jpg";